import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Partner} from "../../models/partner.model";
import {VImage} from "../../models/vet-clinic.model";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {PartnerService} from "../../providers/partner.service";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {FileService} from "../../providers/file.service";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {PartnerBanner} from "../../models/partner-banner.model";
import {PartnerBannersService} from "../../providers/partner-banners.service";

@Component({
  selector: 'app-edit-partner-banner',
  templateUrl: './edit-partner-banner.component.html',
  styleUrls: ['./edit-partner-banner.component.scss'],
})
export class EditPartnerBannerComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() partnerBanner: PartnerBanner;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<PartnerBanner>();
  @Output() objectAddedEmitter = new EventEmitter<PartnerBanner>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  partners: Partner[];
  partner: Partner;
  pbCp: PartnerBanner;

  constructor(
    public commonUtils : CommonUtils,
    private formBuilder: FormBuilder,
    private partnerBannerService: PartnerBannersService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private partnerService: PartnerService,
    private fileService: FileService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.pbCp = JSON.parse(JSON.stringify(this.partnerBanner));
    this.partnerService.listPartners().subscribe(pt => {
      if (pt) {
        this.partners = pt;
        if (this.partnerBanner) {
          this.partner = this.partners.filter(e => e.uuid === this.partnerBanner.partnerVClientUUID)[0]
        }
      }
    });
    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowy baner partnera';
      this.actionBtnLabel = 'Dodaj baner partnera';
      this.actionQuestion = 'Na pewno chcesz dodać baner partnera?';
      this.actionSuccess = 'Baner partnera został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania banera partnera'
      this.formGroup = this.formBuilder.group({
        ruleTags: ['',Validators.required],
        imageUUID: ['', Validators.required],
        partnerVClientUUID: ['', Validators.required]
      });
    } else {
      this.componentTitle = 'Zmień baner partnera';
      this.actionBtnLabel = 'Zmień baner partnera';
      this.actionQuestion = 'Na pewno chcesz zmienić baner partner?';
      this.actionSuccess = 'Baner partnera został zmieniony';
      this.actionError = 'Wystąpił błąd podczas zmiany banera partnera';
      this.formGroup = this.formBuilder.group({
        ruleTags: [this.partnerBanner.ruleTags, Validators.required],
        imageUUID: [this.partnerBanner.imageUUID, Validators.required],
        partnerVClientUUID: [this.partnerBanner.partnerVClientUUID, Validators.required]
      });
    }

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    super.ngOnInit();
    this.appStateService.updateIsBusySubject(false)
  }

  markUnsavedChanges() {
    if(!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  onAction() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let partnerBannerObj: PartnerBanner = this.commonUtils.formGroupValuesToObject<PartnerBanner>(new PartnerBanner(), this.formGroup);

      console.log(partnerBannerObj);
      let serviceMethod;
      partnerBannerObj.imageUUID = this.partnerBanner.imageUUID;
      if (this.action === 'EDIT') {
        partnerBannerObj.uuid = this.partnerBanner.uuid;

        serviceMethod = this.partnerBannerService.updatePartnerBanner(partnerBannerObj);
      } else {
        serviceMethod = this.partnerBannerService.addPartnerBanner(partnerBannerObj);
      }

      this.handleActionMethod(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter);

    }, () => {
    });
  }

  async openImageDropForPhoto(formControlName: 'imageUUID', imageFolder: string) {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vClientUUID': this.partner.uuid,
        'imageFolder': imageFolder || this.commonUtils.generateUUID()
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== null) {
        this.markUnsavedChanges();
        console.log(this.partnerBanner.image);
        this.partnerBanner.image = dismissData.data;
        this.partnerBanner.imageUUID = dismissData.data.uuid;

        this.formGroup.get(formControlName).setValue(dismissData.data?.uuid);

      }
    });

    return await modal.present();
  }

  onChosePartner(event: any) {
    this.partnerBanner.partnerVClientUUID = event.detail.value
    this.partner = this.partners.filter(e => e.uuid === event.detail.value)[0];
  }

  ngOnDestroy() {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  revertImage() {
    this.partnerBanner.image = this.pbCp.image;
    this.partnerBanner.imageUUID = this.pbCp.imageUUID;

  }
}
